<template>
    <div
        class="tw-snap-center tw-flex tw-flex-col tw-group tw-py-3 tw-w-full dark:tw-border-[#223F57] tw-inline"
        :class="wrapperClasses">
        <div class="tw-flex tw-flex-row tw-items-center">
            <!-- Thumbnail Section -->
            <a
            	:href="isReleased && renderLink && !forceNoLinks ? itemUrl : null"
                class="tw-no-underline tw-flex tw-flex-col tw-w-[104px] sm:tw-w-[142px] tw-flex-shrink-0 tw-mr-3"
                :class="[
                    item.type === 'song' ? 'tw-max-w-[121px]' : '',
                    item.type + '-thumbnail'
            	]"
            	@click="openModal"
            >
                <div class="tw-relative tw-overflow-hidden tw-rounded-[10px] tw-bg-white dark:tw-bg-[#0E2031]"
                    :class="item.type === 'song' ? 'tw-aspect-square' : 'tw-aspect-video'"
                >
                    <!-- Video Thumbnail -->
                    <img :src="`https://www.musora.com/cdn-cgi/image/width=500,quality=95/${mappedData.thumbnail} `"
                        class="tw-w-full tw-h-full tw-absolute tw-transition-opacity tw-duration-500 tw-opacity-0"
                        :class="[
                            item.type === 'song' ? 'tw-blur-sm' : ''
                        ]"
                        loading="lazy"
                        onload="this.classList.remove('tw-opacity-0')"
                    >
                    <!-- Song Overlay -->
                    <div v-if="item.type === 'song'"
                        class="tw-absolute tw-w-full tw-h-full tw-left-0 tw-top-0 tw-bg-black/70 tw-flex tw-justify-center">
                        <img class="tw-h-full tw-object-cover" :src="mappedData.thumbnail" :alt="mappedData.black_title" />
                    </div>

                    <!-- Thumbnail Badge -->
                    <div v-if="thumbnailBadge"
                         class="tw-bg-black/70 tw-absolute tw-leading-none tw-uppercase tw-font-bold tw-bottom-1 tw-right-1 tw-rounded tw-text-white tw-text-[10px] tw-p-1">
                         {{ thumbnailBadge }}
                    </div>

                    <!-- Progress -->
                    <div class="lesson-progress overflow">
                        <span class="progress" :class="`tw-bg-${brand}`" :style="'width:' + progress_percent + '%'"></span>
                    </div>
                    <div v-if="showTrophy" class="bundle-complete tw-justify-center">
                        <i class="fas fa-trophy"></i>
                    </div>

                    <!-- EVERYTHING ELSE -->
                    <div
                        v-else
                        class="tw-absolute tw-flex tw-flex-col tw-bg-black/60 tw-w-full tw-h-full tw-justify-center tw-items-center tw-text-white tw-text-center"
                        :class="[{ 'tw-opacity-0 group-hover:tw-opacity-100': isReleased && !noAccess && !isCompleted },]"
                    >
                        <musora-icon v-if="noAccess" class="tw-w-[30px]" icon-name="lock-icon"></musora-icon>
                        <musora-icon v-else-if="isCompleted" icon-name="circle-check-filled" class="tw-text-white tw-w-5 tw-h-5" />
                        <i v-else class="fas" :class="thumbnailIcon"></i>
                        <p v-if="!isReleased" class="tw-mt-1 tw-text-sm text-white font-bold">
                            {{ releaseDate }}
                        </p>
                    </div>
                </div>
            </a>
            <!-- Description Section -->
            <div class="tw-flex tw-w-full">
                <div class="tw-w-full tw-flex tw-flex-wrap lg:tw-block">
                    <a
                        :href="isReleased && renderLink  && !forceNoLinks ? itemUrl : null"
                        class="card-info tw-flex tw-flex-auto tw-flex-col tw-rounded-lg tw-justify-center tw-pt-1"
                        @click="openModal"
                    >
                        <div class="tw-flex tw-flex-col">
                            <!-- Video Title -->
                            <h4 class="tw-text-[13px] sm:tw-text-sm tw-leading-snug tw-text-[#00101D] font-compressed tw-font-bold tw-capitalize tw-mb-1 dark:tw-text-white tw-line-clamp-2"
                                :class="{ 'tw-text-center': isGuitareoChordAndScale }">
                                {{ mappedData.black_title }}
                            </h4>
                            <!-- Video Description -->
                            <p v-if="mappedData.show_description"
                                class="tw-text-xs tw-text-[#3F3F46] dark:tw-text-[#9EC0DC] tw-mb-1 tw-line-clamp-2"
                            >{{  mappedData.description.replace(/<[^>]+>/g, '') }}</p>
                            <!-- Content -->
                            <h6 class="tw-flex tw-items-center tw-flex-wrap tw-text-[11px] sm:tw-text-xs tw-font-normal tw-text-[#3F3F46] tw-uppercase dark:tw-text-[#9EC0DC]"
                                :class="[{ 'tw-text-center': isGuitareoChordAndScale }]">
                                <div v-if="contentCreator && contentCreator !== ''">
                                    <span>{{ contentCreator }}</span>
                                    <span class="tw-mx-1">·</span>
                                </div>
                                <!-- Difficulty Label -->
                                <div v-if="mappedData.difficulty" class="tw-flex tw-items-center" :class="contentCreator && contentCreator !== '' ? 'tw-ml-1' : ''">
                                    <DifficultyLabel class="tw-text-xs" :difficultyValue="mappedData.difficulty"
                                                 textCase="capitalize" />
                                    <span v-if="!isChallenge" class="tw-mx-1">·</span>
                                </div>
                                <div v-if="!isChallenge">
                                    {{ contentTypeString }}
                                </div>
                            </h6>
                            <!-- Bonus label -->
                            <div v-if="item?.is_bonus_content_for_challenge" class="tw-flex tw-mt-1">
                                <div :class="`tw-text-[11px] tw-py-0.5 tw-px-2 tw-text-white tw-bg-${brand} tw-rounded-full`">Bonus</div>
                            </div>
                        </div>
                    </a>
                    <!-- CHALLENGE CTA's -->
                    <template v-if="contentType === 'challenge'">
                        <a v-if="enrollmentOpen && !hasProduct"
                            :href="registrationUrl"
                            class="tw-mt-1 tw-inline-flex tw-items-center tw-justify-center tw-uppercase tw-text-sm tw-px-4 tw-leading-none tw-font-bebas-neue tw-h-[36px] tw-rounded-2xl tw-shadow tw-bg-white dark:tw-bg-[#0E2031] dark:tw-text-[#F1F1F1] tw-text-[#00101D]"
                        >
                            Enroll Now
                        </a>
                        <button v-if="upcomingChallenge" data-open-modal="notifyModal" class="tw-mt-1 tw-inline-flex tw-items-center tw-justify-center tw-uppercase tw-text-sm tw-px-4 tw-leading-none tw-font-bebas-neue tw-h-[36px] tw-rounded-2xl tw-shadow tw-bg-white dark:tw-bg-[#0E2031] dark:tw-text-[#F1F1F1] tw-text-[#00101D]">
                            <musora-icon icon-name="bell" class="tw-w-5 tw-h-5 tw-mr-1"/>
                            Notify Me
                        </button>
                    </template>
                </div>
                <!--
                    Add to Playlist
                    Don't show if the user has not enrolled in a challenge (does not own Product)
                -->
                <div v-if="!enrollmentOpen || hasProduct" class="tw-inline-flex tw-items-start tw-pt-1 tw-px-1 tw-relative">
                    <div class="tw-relative tw-my-auto" v-click-outside="() => { state.dropdownOpen = false }">
                        <button :id="`${item.id}-action-btn-big`" v-if="showMyListAction"
                            class="add-to-list tw-inline-flex tw-rounded-full tw-p-0.5 tw-text-[#00101D] dark:tw-text-white"
                            :class="is_added ? 'is-added' + `tw-text-${brand}` : 'tw-text-[#00101D] dark:tw-text-white'"
                            :title="is_added ? 'Remove from Playlist' : 'Add to Playlist'" :data-content-id="item.id"
                            :data-content-type="item.type"
                            @click.prevent="showDropdown ? handleShowDropdown(`${item.id}-action-btn-big`) : handleAddToList()">
                            <DotsHorizontalIcon v-if="showDropdown" class="tw-h-[24px] tw-w-[24px]" />
                            <svg v-else xmlns="http://www.w3.org/2000/svg" class="tw-h-7 tw-w-7" fill="none"
                                viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
                            </svg>
                        </button>

                        <Dropdown
                            v-if="showDropdown"
                            :brand="brand"
                            :item="item"
                            :is-open="state.dropdownOpen"
                            :dropdownOptions="dropdownOptions"
                            :position="state.dropdownPosition"
                            @closeDropdown="closeDropdown"
                            @addToList="handleAddToList()"
                            @progressReset="$emit('progressReset', { content_id: item.id })"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { computed, onUnmounted, reactive, onMounted, onBeforeMount } from 'vue';
import { DotsHorizontalIcon } from '@heroicons/vue/outline';
import useCatalogueItem from '@hooks/useCatalogueItem.js';
import Dropdown from './Dropdown';
import DifficultyLabel from '@units/DifficultyLabel/DifficultyLabel';
import { contentTypes } from "../../../utils";
import { storeToRefs } from 'pinia';
import { usePlatformStore } from "../../../Stores/platform";
import { useUserStore } from '@stores/user';
import MusoraIcon from '@units/MusoraIcons/MusoraIcon.vue';

//Pinia Stores
const userStore = useUserStore();
const { brand, userHasExpiredMembership, userHasBasicMembership } = storeToRefs(userStore);
const platformStore = usePlatformStore();

const props = defineProps({
    wrapperClassOverride: {
        type: String,
        default: '',
    },
    item: {
        type: Object,
        default: () => ({}), // Default empty object
    },
    contentType: {
        type: String,
        default: '' // Default empty string
    },
    lockUnowned: {
        type: Boolean,
        default: false
    },
    contentTypeOverride: {
        type: String,
        default: ''
    },
    showMyListAction: {
        type: Boolean,
        default: false
    },
    forceNoLinks: {
        type: Boolean,
        default: false
    },
    showDropdown: {
        type: Boolean,
        default: false
    },
    isSingleItem: {
        type: Boolean,
        default: () => false,
    },
    fullWidthOnMobile: {
        type: Boolean,
        default: () => false,
    },
    scrollContainer: {
        type: String,
        default: 'content-container'
    },
    isChallenge: {
        type: Boolean,
        default: false
    },
});

const emit = defineEmits(['addToList', 'progressReset', 'openChallengeLockModal']);

const {
    noAccess,
    contentModel,
    thumbnailIcon,
    renderLink,
    progress_percent,
    isReleased,
    releaseDate,
    isCompleted,
} = useCatalogueItem(props);

const state = reactive({
    dropdownOpen: false,
    dropdownPosition: {
        top: 0,
        left: 0,
        opacity: 0,
    }
});

//-----------Static Data-----------//
const dropdownOptions = [
    {
        name: "Add to Playlist",
        action: "addToList"
    },
    {
        name: "Reset Progress",
        action: "progressReset"
    },
]

const handleShowDropdown = (className) => {
    const { top, left } = document.getElementById(className).getBoundingClientRect();
    const { innerHeight, innerWidth } = window;

    state.dropdownOpen = !state.dropdownOpen;

    //opacity 0 to avoid flicker
    state.dropdownPosition = { ...state.dropdownPosition, opacity: 0 }

    //wait for element to appear on screen
    window.setTimeout(() => {
        const { width, height } = document.getElementById('catalogue-card-dropdown-div').getBoundingClientRect();

        state.dropdownPosition = {
            top: (top + height + 30) < innerHeight ? top + 30 : top - height,
            left: (left + width) < innerWidth ? left : left - width + 26,
            opacity: 1,
        };
    }, 0)
};

const contentTypeString = computed(() => {
    if (contentModel.value?.post?.type && contentTypes[contentModel.value.post.type]?.singular) {
        return contentTypes[contentModel.value.post.type].singular
    }
    return '';
})

const isSongContent = computed(() => {
    return contentModel.value.post.type === 'song'
})

const hasProduct = computed(() => {
    return contentModel.value.post.has_product;
})

const registrationUrl = computed(() => {
    return contentModel.value.post.fields?.find(field => field.key === 'registration_url')?.value || '';
})

const duration = computed( () => {
    let time;
    if(props.item.length_in_seconds) {
        time = props.item.length_in_seconds;
    } else {
        time = props.item.fields?.find(field => field.key === 'length_in_seconds')?.value || '';
    }
    let hours = Math.floor(time / 3600);
    let minutes = Math.floor(time / 60);
    let seconds = time - minutes * 60;
    time = time - hours * 3600;
    return `${hours ? `${hours}:` : ''}${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
})

//Because there are different props for the same thing......
const itemUrl = computed( ()=> {
    return props.item.web_url_path ? props.item.web_url_path : props.item.url;
})

const enrollmentOpen = computed(() => {
    return contentModel.value.post.challenge_state === 'enrollment';
})

const thumbnailBadge = computed(() => {
    if(props.item.type === 'challenge') {
        if(enrollmentOpen.value && !contentModel.value.post.has_product) return 'Enroll Now';
        if(upcomingChallenge.value) return 'Upcoming';
        return `${ props.item.child_count } Workouts`;
    } else if(props.item.type === 'workout') {
        return duration.value;
    } else if(props.item.type === 'course' || props.item.type === 'pack-bundle') {
        return `${ props.item.child_count } Lessons`;
    }else {
        return duration.value;
    }
})

const upcomingChallenge = computed(() => {
    return contentModel.value.post.challenge_state === 'upcoming';
})

const contentCreator = computed(() => {
    if(props.item.instructor) {
        return props.item.instructor;
    } else if(contentModel.value.post.fields) {
        if (isSongContent.value) {
            return contentModel.value.post.fields?.find(field => field.key === 'artist')?.value || ''
        }
        return contentModel.value.post.fields?.find(field => field.key === 'instructor')?.value.name || ''
    }
    return '';
})

const mappedData = computed(() => {
    //Difficulty....
    let difficultyValue = 0; //default
    if(props.item.difficulty) {
        difficultyValue = props.item.difficulty
    } else if (contentModel.value.post.fields) {
        difficultyValue = contentModel.value.post.fields?.find(field => field.key === 'difficulty')?.value || 0;
    }
    contentModel.value.card.difficulty = difficultyValue;

    //Thumbnail....
    if (props.item.thumbnail_url) contentModel.value.card.thumbnail = props.item.thumbnail_url;

    return contentModel.value.card
});

const wrapperClasses = computed(() => {
    return {
    'no-access': noAccess.value,
    completed: isCompleted.value,
    [props.wrapperClassOverride]: props.wrapperClassOverride
}});

const is_added = computed(() => props.item.is_added_to_primary_playlist);
const showTrophy = computed(() => props.item.type === 'pack-bundle' && isCompleted.value);
const isGuitareoChordAndScale = computed(() => brand === 'guitareo' && props.item.type === 'chord-and-scale');

const closeDropdown = () => {
    if (state.dropdownOpen) {
        state.dropdownOpen = false;
    }
};

const handleAddToList = () => {
    const { item: { id, type } } = props;
    const { black_title: name, description, thumbnail } = mappedData.value;
    window.openplaylistmodal({ modalType: 'addItem', content: { content_id: id, type, name, description, thumbnail_url: thumbnail } })
};

const openModal = () => {
    if(props.isChallenge && !isReleased.value){
        emit('openChallengeLockModal', releaseDate.value);
    }
    else if (noAccess.value && userHasExpiredMembership.value) {
        platformStore.redirectToMembershipRenewal(userStore.brand);
    } else if(noAccess.value && userHasBasicMembership.value){
        platformStore.openMembershipUpgradeModal();
    }
}

onMounted(() => {
    const contentContainer = document.getElementById(props.scrollContainer);
    contentContainer.addEventListener('scroll', closeDropdown);
});

onUnmounted(() => {
    const contentContainer = document.getElementById(props.scrollContainer);
    contentContainer.removeEventListener('scroll', closeDropdown);
});
</script>
